<template>
  <div>
    <div ref="autocompleteContainer"></div>
  </div>
</template>

<script>
export default {
  name: "GoogleAutocomplete",
  async mounted() {
    await this.loadGoogleMapsAPI();
  },
  computed: {
    apiKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
    }
  },
  methods: {
    loadGoogleMapsAPI() {
      return new Promise((resolve, reject) => {
        // Check if Google Maps is already loaded
        if (window.google && window.google.maps && window.google.maps.places) {
          console.log("Google Maps API already loaded");
          resolve();
          return;
        }

        // Check if script tag already exists
        const existingScript = document.querySelector(
          'script[src*="maps.googleapis.com/maps/api/js"]'
        );

        if (existingScript) {
          // Script exists, wait for it to load
          const checkLoaded = () => {
            if (
              window.google &&
              window.google.maps &&
              window.google.maps.places
            ) {
              resolve();
            } else {
              setTimeout(checkLoaded, 100);
            }
          };
          checkLoaded();
          return;
        }

        console.log("Loading Google Maps API script");
        const script = document.createElement("script");
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=" +
          this.apiKey +
          "&libraries=places&callback=initGoogleMaps";

        // Set up global callback
        window.initGoogleMaps = () => {
          delete window.initGoogleMaps;
          resolve();
        };

        script.onerror = error => {
          delete window.initGoogleMaps;
          reject(error);
        };

        document.head.appendChild(script);
      }).then(() => {
        console.log("Google Maps API loaded calling initMap");
        return this.initMap();
      });
    },
    async initMap() {
      try {
        console.log("Initializing Google Maps autocomplete");
        const google = window.google;
        await google.maps.importLibrary("places");

        // Initialize the autocomplete
        /* eslint-disable no-undef */
        const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement();
        const container = this.$refs.autocompleteContainer;
        container.appendChild(placeAutocomplete);
        // Set up the place changed listener
        placeAutocomplete.addEventListener(
          "gmp-select",
          async ({ placePrediction }) => {
            const place = placePrediction.toPlace();
            await place.fetchFields({
              fields: [
                "displayName",
                "formattedAddress",
                "location",
                "addressComponents"
              ]
            });
            console.log(
              "place.toJSON()",
              place.toJSON(),
              placeAutocomplete.value
            );
            const inputElement = this.findInputInGmpElement(placeAutocomplete);
            if (inputElement) {
              inputElement.value = place.toJSON().displayName;
            }
            this.$emit("place-selected", place.toJSON());
          }
        );
        /* eslint-enable no-undef */
      } catch (error) {
        console.error("Error initializing Google Maps:", error);
      }
    },
    findInputInGmpElement(gmpElement) {
      // June 5, 2025 Google has an object "inputElement" but it is null. May be used in the future?
      if (gmpElement.inputElement instanceof HTMLInputElement) {
        return gmpElement.inputElement;
      }

      // No Duplicates
      const checkedProps = new Set();

      for (const prop in gmpElement) {
        // Skip if checked or null
        if (checkedProps.has(prop) || !gmpElement[prop]) {
          continue;
        }

        checkedProps.add(prop);

        try {
          const value = gmpElement[prop];
          // is it an input
          if (value instanceof HTMLInputElement) {
            return value;
          }
        } catch (e) {
          // Skip if can't be accessed
          continue;
        }
      }

      console.log("No input element found");
      return null;
    }
  }
};
</script>
<style>
.widget-container {
  background-color: rgb(6, 6, 209) !important;
  color: white !important;
}

/* Style the Google autocomplete dropdown */
gmp-place-autocomplete-element {
  background-color: rgb(6, 6, 209) !important;
}

/* Style the input field inside the autocomplete */
gmp-place-autocomplete-element input {
  background-color: rgb(6, 6, 209) !important;
  color: white !important;
}
</style>
